import React from 'react';
import styles from './ActionButtons.module.css';

interface ActionButtonsProps {
  actions: string[];
  onAction?: (action: string) => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ actions, onAction }) => {
  if (actions.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      {actions.map((action, idx) => (
        <button
          key={idx}
          type="button"
          className={idx === 0 ? styles.primary : styles.secondary}
          onClick={() => onAction?.(action)}
        >
          {action}
        </button>
      ))}
    </div>
  );
};

export default ActionButtons;
